import { useState } from 'react';
import { LumenIcon } from '@photoshelter/socialie-components';

interface Props {
  title: string;
  initialState?: 'open' | 'closed';
  onClickAdd?: () => void;
  children: React.ReactNode;
}

export default function CollapsibleSection(props: Props) {
  const { title, children, initialState = 'open' } = props;
  const [isOpen, setIsOpen] = useState(initialState === 'open');

  return (
    <div className="mb-2">
      <button
        className="bg-muted text-14 mb-1 block h-5 w-full rounded"
        onClick={() => setIsOpen((isOpen) => !isOpen)}
      >
        <span className="text-foreground flex h-full items-center justify-between gap-1 p-1">
          <LumenIcon
            id={isOpen ? 'caret-down' : 'caret-right'}
            className="block h-2 w-2"
          />
          <span className="flex-1 truncate">{title}</span>
        </span>
      </button>

      {isOpen && <div className="border-b pb-2">{children}</div>}
    </div>
  );
}
